<template>
  <div class="container my-5">
    <div v-for="pair in eventPairs" :class="cardDeckClass" :key="pair[0].id + '|' + pair[1].id">
      <EventCard v-for="event in pair" :key="event.id" :event="event"/>
    </div>
    <div :class="cardDeckClass">
      <template v-if="oddNumOfEvents">
        <EventCard :event="lastEvent"/>
        <AddEventCard v-if="upcoming"/>
      </template>
      <template v-else>
        <AddEventCard v-if="upcoming" :last="true"/>
      </template>
    </div>
  </div>
</template>

<script>
import EventCard from '../components/EventCard'
import EventCardAdd from './EventCardAdd'
import { makePairs } from '../utils'

export default {
  components: {
    EventCard: EventCard,
    AddEventCard: EventCardAdd
  },
  props: {
    events: {
      type: Object,
      required: true
    },
    upcoming: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      cardDeckClass: 'card-deck my-4'
    }
  },
  computed: {
    oddNumOfEvents () {
      return Boolean(Object.keys(this.events).length % 2)
    },
    sortedIds () {
      const events = this.events
      let keys = Object.keys(events)

      function compareDates (a, b) {
        if (events[a].date < events[b].date) {
          return -1
        } else {
          return 1
        }
      }

      keys.sort(compareDates)
      return keys
    },
    eventPairs () {
      return makePairs(this.events, { keys: this.sortedIds })
    },
    lastEvent () {
      const sortedIds = this.sortedIds
      return this.events[sortedIds[sortedIds.length - 1]]
    }
  }
}
</script>

<style>
@import "../assets/styles/card.css";
</style>

<style scoped>
.card-deck {
  min-height: 260px;
}
</style>
